export type CircleProps = {
  color: string;
  size?: string;
};

const Circle = ({ color, size = '15px' }: CircleProps) => (
  <div className="circle">
    <div
      style={{
        backgroundColor: color,
        borderRadius: '50%',
        width: size,
        height: size,
        padding: 0,
        margin: 0,
      }}
    />
  </div>
);

export default Circle;
